// Base
import { useMask } from "@react-input/mask";

// Types
import type { ChangeEvent, FC } from "react";

interface ExpirationProps {
  placeholder?: string;
  error?: string;
  name: string;
  type?: string;
  value?: string;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  icon?: React.ReactNode;
  contrast?: boolean;
}

const Expiration: FC<ExpirationProps> = ({
  placeholder,
  error,
  name,
  value,
  handleChange,
  icon,
  contrast,
}) => {
  const inputRef = useMask({ mask: "__/__", replacement: { _: /\d/ } });

  return (
    <div className="w-full flex-1">
      <div>
        <label
          className={`text-sm font-bold whitespace-nowrap ${
            contrast ? "text-cc-dark-gray" : "text-cc-gray"
          }`}
          htmlFor={name}
        >
          {placeholder}
        </label>
        <input
          className={`w-full rounded-md border bg-white p-4 text-sm ${
            contrast
              ? "border-cc-gray-5 placeholder-cc-gray-6"
              : "border-cc-gray-4 placeholder-dark-gray"
          }`}
          ref={inputRef}
          type="tel"
          inputMode="numeric"
          placeholder={placeholder}
          name={name}
          autoComplete="cc-exp"
          value={value}
          onChange={handleChange}
        />
        {icon && <span>{icon}</span>}
      </div>
      {error && <div className="mt-1 text-xs text-red-500">{error}</div>}
    </div>
  );
};

export default Expiration;
